const student = [
  { name: "Dashboard", icon: "fa-tachometer-alt", path: "/dashboard" },
  { name: "Registered User", icon: " fa-user", path: "/registeredUser" },
  { name: "Alumni", icon: " fa-user", path: "/alumni" },

  { name: "Blogs", icon: "fa-marker", path: "/blogs" },
  { name: "Folder", icon: "fa-folder", path: "/folder" },
  { name: "Contacted us", icon: "fa-id-card-alt", path: "/contact" },
  { name: "Job Application", icon: "fa-address-card", path: "/jobApplication" },
  { name: "Awards", icon: "fa-trophy", path: "/awards" },
  { name: "Videos", icon: "fa-video", path: "/videos" },
  { name: "Prescribed Books", icon: "fa-book", path: "/prescribedBooks" },
  { name: "CMS Pages", icon: "fa-file-alt", path: "/cms/pages" },
  { name: "Navigation Menu", icon: "fa-bars", path: "/cms/navigation" },
  { name: "Hero Banner", icon: "fa-image", path: "/cms/hero-banners" },
  { name: "Pop-ups", icon: "fa-window-restore", path: "/cms/popups" },
  { name: "Profile", icon: "fa-user", path: "/profile" },

  // { name: "Categories", icon: " fa-list", path: "/categories" },
  // { name: "Resources", icon: "fa-comment-dots", path: "/resources" },
  // { name: "Testimonial", icon: "fa-th", path: "/testimonials" },
  // { name: "Products", icon: "fa-check", path: "/products" },
  // { name: "Projects", icon: "fa-check", path: "/projects" },
  // { name: "Courses", icon: "fa-book", path: "/courses" },
  // { name: "Competitions", icon: "fa-life-ring", path: "/competitions" },
  // { name: "Query", icon: "fa-comment-dots", path: "/queries" },
];

export { student };
